import { Column } from "../objects/column";
import { DmcProviderListConfiguration } from "../objects/dmcProviderListConfiguration";
import { DmcProviderListCriteria } from "../objects/dmcProviderListCriteria";
import { DmcProviderListFiltersCriteria } from "../objects/dmcProviderListFiltersCriteria";



export const EMPTY_DMC_PROVIDER_FILTERS: DmcProviderListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
    name: "",
    activated: "BOTH",
    circuit_is_active: "BOTH",
    content_type: []
};

export const EMPTY_DMC_PROVIDER_LIST_CRITERIA: DmcProviderListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
    filters: EMPTY_DMC_PROVIDER_FILTERS,
    search: ''
};


export const DEFAULT_COLUMN: Column[] = [{
    label: 'provider-name',
    field_name: 'PROVIDER_NAME',
    checked: true,
    order_by: 'provider__name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'content-types',
    field_name: 'CONTENT_TYPE',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'circuit-is-active',
    field_name: 'CIRCUIT_IS_ACTIVE',
    checked: true,
    order_by: 'circuit_is_active',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: true,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false,
    width: null
}];

export const EMPTY_DMC_PROVIDER_LIST_CONFIGURATION: DmcProviderListConfiguration = {
    columns: DEFAULT_COLUMN,
    preferences: []
};

export const DMC_PROVIDER_MODULE = 'DMC_PROVIDER_MODULE';
